import React from 'react';
import styles from './styles.css';

const TaxableTransferConfirmation = ({ loadedData }) => {
  const openPDF = () => {
    try {
      window.open(loadedData?.mutualFundFormURL, '_blank');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  };

  return (
    <>
      <section className="next-instructions">
        <div className="step-contents">
          <h3>Complete your transfer</h3>
          <strong>Complete the following to process your transfer</strong>
          <ol>
            <li>
              <p>
                Download and complete the Mutual Fund Transfer Form
                <br />{' '}
                <span className="download-form">
                  <span className="download-icon" />
                  <a
                    id="open-pdf-link"
                    role="button"
                    onClick={openPDF}
                    onKeyDown={openPDF}
                    tabIndex="0">
                    Mutual Fund Transfer Form
                  </a>
                </span>
              </p>
            </li>
            <li>
              <strong>Attach your latest statement</strong>
              <p>Attaching your latest statement makes the process faster</p>
            </li>
            <li>
              <strong>Mail in your form</strong>
              <br />
              <br />
              <address>
                T. Rowe Price
                <br />
                P.O. Box 17150
                <br />
                Baltimore, MD 21297-1150
              </address>
            </li>
          </ol>
        </div>
      </section>
      <style jsx>{styles}</style>
    </>
  );
};

export default TaxableTransferConfirmation;
